// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1GbM4","title":"AfterBackImages_title__XztCm","images":"AfterBackImages_images__i6o5n"};